import MeetingIcon from 'src/assets/icons/fi-rr-calendar.svg';
import { FieldMappingsMockUpType } from '../types';

export const selectedData = {
  value: '',
  to_crm_if_blank: true,
  from_sprouts: false,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};
export const selectedDataNew = {
  value: '',
  to_crm_if_blank: false,
  from_sprouts: true,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};

// For fields that should NOT sync from CRM to Sprouts (outbound only)
export const selectedDataOutboundOnly = {
  value: '',
  to_crm_if_blank: false,
  from_sprouts: true,
  nosync: false,
  // crm to sproutes - DISABLED for outbound-only fields
  toSprouts: false,
  dontSyncToSprouts: true,
};

export const MeetingFieldMappings: FieldMappingsMockUpType = {
  id: 'meeting',
  label: 'Meeting',
  testRunId: 'meetings',
  testRunLabel: 'Meetings',
  icon: MeetingIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Events',
  sproutsFields: [
    {
      label: 'Name',
      id: 'name',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Source',
      id: 'source',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Description',
      id: 'body',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'External URL',
      id: 'externalUrl',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Created At',
      id: 'createdAt',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Updated At',
      id: 'updatedAt',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Prospect As Quest',
      id: 'prospectAsQuest',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Start Time',
      id: 'startTime',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Sequence ID',
      id: 'sequenceId',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'CMP ID',
      id: 'cmpId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
    {
      label: 'Step ID',
      id: 'stepId',
      selectedData,
      onlyOutbound: false,
    },
    {
      label: 'Contact ID',
      id: 'contactId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
    {
      label: 'User ID',
      id: 'userId',
      selectedData,
      required: true,
      onlyOutbound: false,
    },
  ],
};

export const MeetingFieldMappingsExpandedActivity: FieldMappingsMockUpType = {
  id: 'meeting',
  label: 'Meeting',
  testRunId: 'meetings',
  testRunLabel: 'Meetings',
  icon: MeetingIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Events',
  sproutsFields: [
    {
      label: 'Meeting Subject',
      id: 'name',
      selectedData: selectedDataNew,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Meeting Body',
      id: 'description',
      selectedData: selectedDataNew,
      onlyOutbound:false,
      disableToCrmIfBlank: true,
      required: true,
    },
      {
      label: 'Sequence Name',
      id: 'sequenceName',
      selectedData: selectedDataOutboundOnly,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Step Number',
      id: 'stepNumber',
      selectedData: selectedDataOutboundOnly,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Activity Time',
      id: 'startTime',
      selectedData: selectedDataNew,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Meeting Duration',
      id: 'duration',
      selectedData: selectedDataNew,
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
  ],
};